import createIcon from '../../createIcon';

/**
 * @component @name BroadcastOnPersonal
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuMjUgNy41QzE1Ljk1IDcuNSAxNi42MyA3LjYgMTcuMjcgNy43N0wxMC4yNSAyLjVMMi4yNSA4LjVWMjAuNUg5LjAxQzcuOTEgMTkuMTMgNy4yNSAxNy4zOSA3LjI1IDE1LjVDNy4yNSAxMS4wOCAxMC44MyA3LjUgMTUuMjUgNy41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE1LjI1IDE0LjI1QzE0LjU2IDE0LjI1IDE0IDE0LjgxIDE0IDE1LjVDMTQgMTUuOSAxNC4yIDE2LjI1IDE0LjUgMTYuNDdWMjEuNUgxNlYxNi40N0MxNi4zIDE2LjI0IDE2LjUgMTUuOSAxNi41IDE1LjVDMTYuNSAxNC44MSAxNS45NCAxNC4yNSAxNS4yNSAxNC4yNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNS4yNSAxMS41QzEzLjA0IDExLjUgMTEuMjUgMTMuMjkgMTEuMjUgMTUuNUMxMS4yNSAxNi42IDExLjcgMTcuNiAxMi40MiAxOC4zM0wxMy40OCAxNy4yN0MxMy4wMyAxNi44MiAxMi43NSAxNi4xOSAxMi43NSAxNS41QzEyLjc1IDE0LjEyIDEzLjg3IDEzIDE1LjI1IDEzQzE2LjYzIDEzIDE3Ljc1IDE0LjEyIDE3Ljc1IDE1LjVDMTcuNzUgMTYuMTkgMTcuNDcgMTYuODEgMTcuMDIgMTcuMjZMMTguMDggMTguMzJDMTguOCAxNy42IDE5LjI1IDE2LjYgMTkuMjUgMTUuNUMxOS4yNSAxMy4yOSAxNy40NiAxMS41IDE1LjI1IDExLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTUuMjUgOUMxMS42NiA5IDguNzUgMTEuOTEgOC43NSAxNS41QzguNzUgMTcuMjkgOS40OCAxOC45MiAxMC42NSAyMC4xTDExLjcxIDE5LjA0QzEwLjgxIDE4LjEzIDEwLjI1IDE2Ljg4IDEwLjI1IDE1LjVDMTAuMjUgMTIuNzQgMTIuNDkgMTAuNSAxNS4yNSAxMC41QzE4LjAxIDEwLjUgMjAuMjUgMTIuNzQgMjAuMjUgMTUuNUMyMC4yNSAxNi44NyAxOS42OSAxOC4xMiAxOC43OSAxOS4wMkwxOS44NiAyMC4wOEMyMS4wMyAxOC45IDIxLjc1IDE3LjI4IDIxLjc1IDE1LjVDMjEuNzUgMTEuOTEgMTguODQgOSAxNS4yNSA5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BroadcastOnPersonal = createIcon('BroadcastOnPersonal', [
  [
    'path',
    {
      d: 'M15.25 7.5C15.95 7.5 16.63 7.6 17.27 7.77L10.25 2.5L2.25 8.5V20.5H9.01C7.91 19.13 7.25 17.39 7.25 15.5C7.25 11.08 10.83 7.5 15.25 7.5Z',
      key: '1wh9w1',
    },
  ],
  [
    'path',
    {
      d: 'M15.25 14.25C14.56 14.25 14 14.81 14 15.5C14 15.9 14.2 16.25 14.5 16.47V21.5H16V16.47C16.3 16.24 16.5 15.9 16.5 15.5C16.5 14.81 15.94 14.25 15.25 14.25Z',
      key: '15bczd',
    },
  ],
  [
    'path',
    {
      d: 'M15.25 11.5C13.04 11.5 11.25 13.29 11.25 15.5C11.25 16.6 11.7 17.6 12.42 18.33L13.48 17.27C13.03 16.82 12.75 16.19 12.75 15.5C12.75 14.12 13.87 13 15.25 13C16.63 13 17.75 14.12 17.75 15.5C17.75 16.19 17.47 16.81 17.02 17.26L18.08 18.32C18.8 17.6 19.25 16.6 19.25 15.5C19.25 13.29 17.46 11.5 15.25 11.5Z',
      key: 'hrykz',
    },
  ],
  [
    'path',
    {
      d: 'M15.25 9C11.66 9 8.75 11.91 8.75 15.5C8.75 17.29 9.48 18.92 10.65 20.1L11.71 19.04C10.81 18.13 10.25 16.88 10.25 15.5C10.25 12.74 12.49 10.5 15.25 10.5C18.01 10.5 20.25 12.74 20.25 15.5C20.25 16.87 19.69 18.12 18.79 19.02L19.86 20.08C21.03 18.9 21.75 17.28 21.75 15.5C21.75 11.91 18.84 9 15.25 9Z',
      key: '1a7xgz',
    },
  ],
]);

export default BroadcastOnPersonal;
